import React from "react";
import { MaskLine } from "./primitives";
import { ArcMotif } from "./Graphics";

export default function Philosophy() {
  return (
    <section data-testid="philosophy-section" className="relative overflow-hidden bg-warm py-36 md:py-56">
      <ArcMotif className="pointer-events-none absolute right-4 top-16 h-40 w-72 text-copper/25 md:right-24 md:h-56 md:w-[32rem]" />
      <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-12">
        <h2 className="font-serif text-4xl leading-[1.15] text-ink sm:text-6xl lg:text-[5rem] lg:leading-[1.1]">
          <MaskLine trigger="load" delay={0}>Beautiful homes exist.</MaskLine>
          <MaskLine trigger="load" delay={0.08}>Profitable villas exist.</MaskLine>
          <MaskLine trigger="load" delay={0.16}>Meaningful family homes exist.</MaskLine>
          <MaskLine trigger="load" delay={0.24} className="text-ink/35">
            Very few become all three.
          </MaskLine>
          <MaskLine trigger="load" delay={0.34} className="italic text-forest">
            That is what we create.
          </MaskLine>
        </h2>
      </div>
    </section>
  );
}
